export default {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge":604800,"secure":true},
 clients: {"default":{"httpEndpoint":"https://gapi.storyblok.com/v1/api","httpLinkOptions":{"headers":{"Token":"CcBMQQK2K27Rkkr0YC6Gvwtt","Version":"published"}},"authType":"Bearer","authHeader":"Authorization","tokenName":"apollo:default.token","tokenStorage":"cookie"}}
}